import { HTags } from "@shared/src/datatypes/HTags";
import { HDate } from "@shared/src/datatypes/HDate";
import { HHourInterval } from "@shared/src/datatypes/HHourInterval";
import { DockSlotPhaseDto } from "./DockSlotPhaseDto";
import { DockSlotsDto } from "./DockSlotsDto";

export class AddressDockIntervalBaseDto {

    public addressTimetableIntervalId: number;
    public addressDaySettingId: number;

    public onDate: HDate;
    public interval: HHourInterval;
    public intervalDock: HHourInterval;
    public intervalWheelbarrowDriver: HHourInterval;
    public dockSlotCount: number = 0;
    public dockSlotOccupied: number = 0;
    public dockSlotAvailable: number = 0;
    public dockSlots: Array<DockSlotPhaseDto>;
    public dockSlotsColumn: Array<DockSlotsDto>;
    public dockSlotsPending: Array<DockSlotPhaseDto>;
    public userTags: HTags;
    public backColor: string;

    public canalterelement: boolean;

     static getInterval(y: AddressDockIntervalBaseDto, slotsMode: String): HHourInterval {
        if ("FORKLIFT" == slotsMode)
            return y.intervalWheelbarrowDriver;
        else if ("DOCK" === slotsMode)
            return y.intervalDock;

        return y.interval;
    }
}